"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("./Modal.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'TimerexModal',
    setup(__props, { expose: __expose }) {
        const isVisible = (0, vue_3.ref)(false);
        function scrollToTimerexCalendar() {
            window.setTimeout(() => {
                const modalBody = document.querySelector(".timerex-modal .modal-body");
                const calendar = document.getElementById("timerex_calendar");
                if (modalBody && calendar) {
                    modalBody.scrollTop = calendar.offsetTop;
                }
            }, 200);
        }
        function initializeTimerex() {
            const timerexWindow = window;
            const initialize = () => {
                timerexWindow.TimerexCalendar?.({
                    onFormOpen: scrollToTimerexCalendar,
                    onBookingComplete: scrollToTimerexCalendar,
                });
            };
            if (timerexWindow.TimerexCalendar) {
                initialize();
                return;
            }
            const existingScript = document.getElementById("timerex_embed");
            if (existingScript) {
                existingScript.addEventListener("load", initialize, { once: true });
                return;
            }
            const script = document.createElement("script");
            script.id = "timerex_embed";
            script.src = "https://asset.timerex.net/js/embed.js";
            script.addEventListener("load", initialize, { once: true });
            document.head.appendChild(script);
        }
        function openModal() {
            isVisible.value = true;
            (0, vue_3.nextTick)(initializeTimerex);
        }
        function closeModal() {
            isVisible.value = false;
        }
        __expose({
            openModal,
            closeModal,
        });
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    class: "timerex-modal",
                    "has-title-divider": true,
                    "include-modal-footer": false,
                    onCloseModal: closeModal
                }, {
                    "header-title": (0, vue_2.withCtx)(() => [...(_cache[0] || (_cache[0] = [
                            (0, vue_2.createTextVNode)("お客様の声をお聞かせください", -1 /* CACHED */)
                        ]))]),
                    content: (0, vue_2.withCtx)(() => [...(_cache[1] || (_cache[1] = [
                            (0, vue_2.createElementVNode)("div", { class: "timerex-modal-content" }, [
                                (0, vue_2.createElementVNode)("p", null, "お客様からいただくご意見は、サービス向上のための大切な参考となります。カスタマーサクセスチームとの短時間のミーティングをご予約いただき、oplusをご利用いただいたご感想や、改善に向けたご要望をぜひお聞かせください。"),
                                (0, vue_2.createElementVNode)("div", {
                                    id: "timerex_calendar",
                                    "data-url": "https://timerex.net/s/opluswork_sales/42c472c5"
                                })
                            ], -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
